import { defineMessage } from 'services/localization';

export const messages = {
    totalAllocatedText: defineMessage('total_2'),
    itemColumnName: defineMessage('name'),
    approvedColumnName: defineMessage('approved'),
    matchedByColumnName: defineMessage('matched_by'),
    allocatedAmountColumnName: defineMessage('allocated_amount_to_this_po'),
    totalAmountColumnNameWithGross: defineMessage('total_amount_gross'),
    totalAmountColumnNameWithNet: defineMessage('total_amount_net'),
};
